
import * as cloudflareRuntime$RVagY4gurS3GcXlUXIbSFt4x_45nHXH6apKC7sIyQE2a0 from '/opt/buildhome/repo/src/nuxt/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1440,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudflare",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['cloudflare']: { provider: cloudflareRuntime$RVagY4gurS3GcXlUXIbSFt4x_45nHXH6apKC7sIyQE2a0, defaults: {"baseURL":"https://thisismess.io"} }
}
        